import { render, staticRenderFns } from "./statisticsSum.vue?vue&type=template&id=5d87b771&scoped=true&"
import script from "./statisticsSum.vue?vue&type=script&lang=js&"
export * from "./statisticsSum.vue?vue&type=script&lang=js&"
import style0 from "./statisticsSum.vue?vue&type=style&index=0&id=5d87b771&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d87b771",
  null
  
)

export default component.exports